import {Button, ButtonSize, ButtonVariant} from '../button'
import * as Styled from './error-fallback.styled'

import type {JSX} from 'react'

interface ErrorFallbackProps {
    errorMessage: string
    retryButtonText: string
    showRetryButton: boolean
    resetErrorBoundary: () => void
}

export function ErrorFallback({
    errorMessage,
    retryButtonText,
    showRetryButton,
    resetErrorBoundary,
}: ErrorFallbackProps): JSX.Element {
    return (
        <Styled.ErrorContainer>
            <Styled.ErrorMessage>{errorMessage}</Styled.ErrorMessage>
            {showRetryButton && (
                <Button
                    variant={ButtonVariant.Outlined}
                    size={ButtonSize.SM}
                    onPress={resetErrorBoundary}
                >
                    {retryButtonText}
                </Button>
            )}
        </Styled.ErrorContainer>
    )
}
